<template>
  <div class="modal-card" ref="element">

    <header class="modal-card-head">
      <p class="modal-card-title">Existing resources</p>
    </header>

    <section class="modal-card-body" >
                    <div v-if="noResources">There are no existing video resources yet.</div>
        <main class="grid">
          <div v-for="(im,id) in libVideos" :key="id">
<my-video class="__cov-video"
    :sources="[{
          src: im.url,
          type: 'video/mp4'
        }]" :options="video.options"></my-video>
            <span @click="selectVideo(im.url, im.name, im.file)" :class="{ active: hover }" class="caption" :style="im.url === selectedUrl ? 'font-weight: bold' : ''" style="cursor:pointer">
                {{im.name}}
            </span>
          </div>
        </main>
     </section>
     <footer v-if="!noResources" class="modal-card-foot" style="background-color:white;border-radius:0px">
         <p><b>Selected video: </b>{{selectedName}}</p>
  </footer>

    <footer class="modal-card-foot">
      <b-button v-if="!noResources" type="is-info" @click="uploadVideo()">Select</b-button>
      <b-button type="is-light" @click="closeModal()">Cancel</b-button>
    </footer>

  </div>
</template>

<script>
import myVideo from 'vue-video'

export default {
  name: 'VideosLibrary',
  props: ['propParent'],
  components: {
    myVideo
  },
  data: () => {
    return {
      libVideos: [],
      loadingComponent: null,
      selectedUrl: '',
      selectedName: '',
      selectedFile: null,
      video: {
        // sources: ,
        options: {
          autoplay: false,
          volume: 0.6
          // poster: '/static/images/blackk.jpg'
        }
      },
      hover: false,
      noResources: false
    }
  },
  mounted: function () {
    this.loadingComponent = this.$buefy.loading.open()
    if (this.$store.state.playlists === null) {
      this.loadingComponent.close()
      this.noResources = true
    } else {
      var pl = this.$store.state.playlists
      var hasVideos = false
      for (let playlist in pl) {
        if (pl[playlist].items) {
          for (let i = 0; i < pl[playlist].items.length; i++) {
            if (pl[playlist].items[i].resourceName) {
              var ext = pl[playlist].items[i].resourceName.split('.')[1]
              if (ext === 'mov' || ext === 'mp4' || ext === 'avi' || ext === 'mkv') {
                hasVideos = true
                break
              }
            }
          }
        }
      }
      if (hasVideos === false) {
        this.loadingComponent.close()
        this.noResources = true
      } else {
        for (let playlist in this.$store.state.playlists) {
          var playlistDirsRef = null
          if (!this.getNotMigrated().includes(this.$store.state.uid)) {
            playlistDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Playlists/' + playlist)
          } else {
            playlistDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Playlists/' + playlist)
          }
          playlistDirsRef.listAll().then((dir) => {
            dir.items.forEach(fileRef => {
              fileRef.getDownloadURL().then((url) => {
                const xhr = new XMLHttpRequest()
                xhr.responseType = 'blob'
                xhr.onload = (event) => {
                  const blob = xhr.response
                  if (blob.type.split('/')[0] === 'video') {
                    var file = new File([blob], fileRef.name, {type: blob.type})
                    this.libVideos.push({ 'name': fileRef.name, 'url': url, 'file': file })
                  }
                  this.loadingComponent.close()
                }
                xhr.open('GET', url)
                xhr.send()
              }).catch((error) => {
                this.globalLogger('error', error)
              })
            })
          })
        }
      }
      // }
      this.globalLogger('PL: ', pl)
    }
  },
  methods: {
    closeModal () {
      this.$parent.close()
    },
    selectVideo (url, name, file) {
      this.selectedUrl = url
      this.selectedName = name
      this.selectedFile = file
    },
    uploadVideo () {
      this.propParent(this.selectedFile)
      this.$parent.close()
    }
  }
}
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap:20px;
  align-items: center;
  }
.grid img {
  box-shadow: 2px 2px 6px 0px  rgba(0,0,0,0.3);
  max-width: 100%;
}
.active {
  color: #3e8ed0;
  cursor: pointer;
}
.caption {
    display: block;
    font-size: 10pt;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/playlists/items/VideosLibrary.vue